module.exports = __webpack_public_path__ + "img/logo-icon.9bc4411b.png";